import Backbone, {EventsMixin} from 'backbone';
import window from 'global/window';

/**
 * Backbone dispatcher instance.
 * @see https://backbonejs.org/#Events
 * @example
 * dispatcher.on('foo', () => console.log('bar'));
 * dispatcher.trigger('foo'); // 'bar'
 */
export const dispatcher = {...Backbone.Events} as EventsMixin;
// lots of global use out there still
window.dispatcher = dispatcher;
export default dispatcher;

/**
 * Enhanced Backbone dispatcher instance.\
 * Provides a cleanup function for each event binding method.
 *
 * @example
 * const cleanup = enhancedDispatcher.on('foo', () => console.log('bar'));
 * cleanup(); // removes the event binding
 */
export const enhancedDispatcher = {
	...dispatcher,
	bind: (eventName: string, cb: Backbone.EventHandler, context?: any) => {
		dispatcher.bind(eventName, cb, context);
		return () => {
			dispatcher.unbind(eventName, cb, context);
		};
	},
	on: (eventName: string, cb: Backbone.EventHandler, context?: any) => {
		dispatcher.on(eventName, cb, context);
		return () => {
			dispatcher.off(eventName, cb, context);
		};
	},
	once: (eventName: string, cb: Backbone.EventHandler, context?: any) => {
		dispatcher.once(eventName, cb, context);
		return () => {
			dispatcher.off(eventName, cb, context);
		};
	},
	listenTo: (eventName: string, cb: any, context?: any) => {
		dispatcher.listenTo(eventName, cb, context);
		return () => {
			dispatcher.stopListening(eventName, cb, context);
		};
	},
	listenToOnce: (eventName: string, cb: any) => {
		dispatcher.listenToOnce(eventName, cb);
		return () => {
			dispatcher.stopListening(eventName, cb);
		};
	},
};
